import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import { resetState } from 'Features/Learning/FAQProgram/addFAQProgramSlice';
import { useSelector, useDispatch } from 'react-redux';
import FAQProgramBox from './FAQProgramBox';
import FAQProgramFilter from './FAQProgramFilter';

const FAQProgramContain = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const cards = useSelector(state => state.FAQProgram.data.data)

  const toggle = () => setModal(prev => !prev);

  const handleAdd = (e) => {
    dispatch(resetState());
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Col md="12" className="project-list">
          {cards && (
            <Card>
              <Row>
                <Col>
                  {/* <Link to={`${process.env.PUBLIC_URL}/fAQ-program/form`} onClick={handleAdd}> */}
                  <Button color="primary" onClick={e => {
                    e.preventDefault();
                    handleAdd(e);
                    toggle();
                  }}>
                    <i className="fa fa-plus-circle fa-lg"></i> Tambah FAQ Baru
                  </Button>
                  {/* </Link> */}
                </Col>
              </Row>
            </Card>
          )}
        </Col>
        <Row className='learning-block'>
          <Col xl="9" className='xl-80'>
            <Row>
              <FAQProgramBox modal={modal} toggle={toggle} />
            </Row>
          </Col>
          {cards && (
            <FAQProgramFilter />
          )}
        </Row>
      </Container>
    </Fragment>
  );
};

export default FAQProgramContain;